import PropTypes from 'prop-types';
import { useState, lazy } from 'react';
import { Navigate, useLocation } from 'react-router';
//* components
// import LoadingScreen from 'src/components/LoadingScreen';
//* Components
const LoadingScreen = lazy(() => import('src/components/LoadingScreen.jsx'));
const Login = lazy(() => import('src/pages/auth/Login.jsx'));
// import Login from 'src/pages/auth/Login';

//* ----------------------------------------------------------------------

export default function AuthGuard({ children }) {
  const { pathname, state } = useLocation();
  const isContactCenter = pathname?.includes('contactcenter');
  const [requestedLocation, setRequestedLocation] = useState(null);
  const { isAuth = true, isInit = true } = { ...state };

  const isAuthenticated = isAuth;
  const isInitialized = isInit;

  if (!isInitialized) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    if (pathname !== requestedLocation) {
      setRequestedLocation(pathname);
    }
    return <Login isContactCenter={isContactCenter} />;
  }

  if (requestedLocation && pathname !== requestedLocation) {
    setRequestedLocation(null);
    return <Navigate to={requestedLocation} />;
  }

  return <>{children}</>;
}
AuthGuard.propTypes = {
  children: PropTypes.node,
};
